module.exports = "<div class=\"page-container\">\r\n\r\n    <util-sidebar\r\n        [app]=\"app\"\r\n        [verzija]=\"verzija\"\r\n        [datum]=\"datum\">\r\n    </util-sidebar>\r\n\r\n    <div class=\"page-content\">\r\n        <util-header [app]=\"app\"></util-header>\r\n        <router-outlet></router-outlet>\r\n    </div>\r\n</div>\r\n<div id=\"modal-parent\"><div id=\"modal\"></div></div>\r\n<div id=\"modal-popup-parent\"><div id=\"modal-popup\"></div></div>\r\n<ngx-loading-bar></ngx-loading-bar>"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/pages.component.html
// module id = ./src/app/pages/pages.component.html
// module chunks = main